export const environment = {
    production: true,
    userStorage: 'userInfoPre',
    organizationalStructure: 'structurePre',
    organizationalStructureWO: 'structureWOPre',
    manualLogin: 'manualLoginPre',
    jwt: 'JwtPre',
    moduleId : 70,
    securityServices:"https://apptemplate:90/Security",
    notaServices:"https://apptemplate:90/Nota",
    commonServices: "https://apptemplate:90/Common",
    adminServices: "https://applecturas-pre.aqualia.es/Lecturas/admin",
    apiServices: "https://applecturas-pre.aqualia.es/Lecturas/api",
    protocol: "https",
    version: "2.8"
  };
